import FUNDRAISER_ROUTES from './fundraiser'

const routeDashboard = '/dashboard'

export const ROUTES = {
  root: {
    key: 'root',
    title: 'صفحه اصلی | زیما',
    name: 'زیما',
    href: '/',
  },
  register: {
    key: 'register',
    title: 'ثبت نام زیما',
    name: 'ثبت نام زیما',
    href: '/register',
  },
  registerMobile: {
    key: 'register-user',
    title: 'ثبت نام زیما',
    name: 'ثبت نام زیما',
    href: '/register-user',
  },
  otpVerification: {
    key: 'otp-verification',
    title: 'تایید شماره موبایل زیما',
    name: 'تایید شماره موبایل زیما',
    href: '/otp-verification',
  },
  mobileOtpVerification: {
    key: 'mobile-otp-verification',
    title: 'تایید شماره موبایل زیما',
    name: 'تایید شماره موبایل زیما',
    href: '/mobile-otp-verification',
  },
  login: {
    key: 'login',
    title: 'ورود سایت زیما',
    name: 'ورود / ثبت‌نام',
    href: '/login',
  },
  crowdfundingPlan: {
    key: 'crowdfundingPlan',
    title: 'لیست طرح های کرادفاندینگ زیما',
    name: 'مشاهده طرح‌های سرمایه‌گذاری',
    href: '/crowdfunding-plan',
  },
  crowdfundingInvest: {
    key: 'crowdfundingInvest',
    title: 'سرمایه گذاری در طرح زیما',
    name: 'سرمایه گذاری در طرح زیما',
    href: '/crowdfunding/invest',
  },
  userCrowdfundingPlan: {
    key: 'userCrowdfundingPlan',
    title: 'طرح های من',
    name: 'سرمایه‌گذاری‌های من',
    href: '/user-crowdfunding-plan',
  },
  dashboard: {
    root: {
      key: 'dashboard',
      title: 'پروفایل من',
      name: 'پروفایل من',
      href: routeDashboard,
    },
    userInformation: {
      key: 'userInformation',
      title: 'اطلاعات کاربری - پروفایل من',
      name: 'اطلاعات کاربری',
      href: `${routeDashboard}/user-information`,
    },
  },
  rules: {
    key: 'rules',
    title: 'قوانین و مقررات زیما',
    name: 'قوانین و مقررات زیما',
    href: '/rules',
  },
  faq: {
    key: 'faq',
    title: 'سوالات متداول پلتفرم کرادفاندینگ زیما',
    name: 'پرسش‌های متداول',
    href: '/faq',
  },
  about: {
    key: 'about',
    title: 'درباره زیما پلتفرم تامین مالی جمعی',
    name: 'درباره زیما',
    href: '/about',
  },
  ...FUNDRAISER_ROUTES,
}
